import Http from '@/common/libs/http'
import store from '@/store'
const config = JSON.parse(process.env.VUE_APP_CONFIG)

const newHttp = function({ apiPrefix = '' }) {
  return new Http(
    {
      baseUrl: `${config.BASE_API}`,
      apiPrefix: `${apiPrefix || config.apiPrefix}`
    },
    {
      // 设置请求前拦截器
      request: config => {
        config.header = {
          'X-Access-Token': uni.getStorageSync('cookie') || ''
        }
      },
      // 设置请求结束后拦截器
      // response: response => {
      //   const { statusCode } = response
      //   if (statusCode.toString().startsWith('2')) {
      //     return response.data
      //   }
      // },
      error: (response, reject) => {
        const { statusCode, data = {} } = response
        let message = ''
        switch (statusCode) {
          case 403:
          case 500:
            message = data.message
            break
        }
        if (message) {
          store.commit('toast/setOptions', {
            type: 'prompt',
            message: message,
            visible: true
          })
        }
        if (statusCode === 401 || statusCode === 412) {
          // uni.hideLoading()
          store.commit('toast/setOptions', {
            message: uni.getStorageSync('cookie')
              ? '您登录已过期，是否重新登录?'
              : '您还未登录，是否进行登录?',
            type: 'popup',
            visible: true,
            onSuccess: () => {
              uni.navigateTo({
                url: '/pages/login/index'
              })
            },
            onError: () => {
              uni.switchTab({
                url: '/pages/home/index'
              })
            },
            onComplete: () => {
              if (uni.getStorageSync('cookie')) {
                uni.removeStorageSync('cookie')
                uni.removeStorageSync('user_id')
                uni.removeStorageSync('phone')
                uni.removeStorageSync('personal_data')
                uni.removeStorageSync('im_id')
                uni.removeStorageSync('openid')
                uni.removeStorageSync('invitation_code')
                store.commit('socket/imId', '')
                store.commit('socket/closeSocket')
              }
            }
          })
        }
        return reject(data, response)
      }
    }
  )
}

// 小程序b2c
const b2cQequest = newHttp({})
// 通讯
const imQequest = newHttp({ apiPrefix: '/api-im' })
// 通用
const universal = newHttp({ apiPrefix: '/api-universal' })

export default b2cQequest
export const imAsk = imQequest
export const universalAsk = universal
